export default __webpack_public_path__ + "static/media/custom_end_cap.fb191d20.jpg";